module.exports = __webpack_public_path__ + "static/media/QuestionIconBlack.b2af8a8e.svg";